// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".withdrawal_complete_wrap .complete_box {\n  border-radius: 3px;\n  background-color: #f5f6f9;\n  padding: 100px 0px;\n  text-align: center;\n  box-sizing: border-box;\n  margin-top: 40px !important; }\n  @media (max-width: 768px) {\n    .withdrawal_complete_wrap .complete_box {\n      padding: 40px 4%; } }\n  .withdrawal_complete_wrap .complete_box h1 {\n    font-size: 24px;\n    line-height: 1;\n    margin-top: 18px;\n    margin-bottom: 8px;\n    font-weight: 300; }\n  .withdrawal_complete_wrap .complete_box h2 {\n    font-size: 14px;\n    line-height: 1.29; }\n", ""]);
// Exports
module.exports = exports;



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader/dist/cjs.js!../node_modules/sass-loader/lib/loader.js!./Src/Containers/User/WithdrawalComplete.scss
// module id = 2381
// module chunks = 1